// Legacy UiDescription.vue's title and alternate title: `text-font-primary` (--q-text-primary) in light, and plain
// `text-white` (#fff) in the dark theme, where every other primary text is 87 % white (B1518).
export const DESCRIPTION_TITLE_INK = 'text-text-1 dark:text-white';
